import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { getSITemplateSettings, toggleComponent, confirmDialogBox } from "../../../../redux/actions/si_template_setting/si_template_setting.actions";
import { MiniSpinner } from "../../../layouts/Spinner";


function SITSList({ loading, si_template_settings, getSITemplateSettings, toggleComponent, confirmDialogBox }) {

    useEffect(() => {
        getSITemplateSettings()
    },[])

    console.log(si_template_settings);

    return (
        <div className="row">
            {
                loading ? <div className="col-6 justify-content-center py-5 px-5"><MiniSpinner/></div> :
                <>
                    {
                        si_template_settings && si_template_settings.map(si => (
                            <div className="col-lg-2 col-sm-6 col-12">
                                <div className="card temp-box">
                                    <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                        <div className="mr-auto">
                                            <i className="ft ft-more-horizontal temp-box-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                { !si.main_template && <button onClick={() => toggleComponent('edit_copy', si)} class="dropdown-item" type="button">Edit</button> }
                                                { si.is_default ? null : !si.is_custom_template ? <button onClick={() => confirmDialogBox('set_default', si)} class="dropdown-item" type="button">Set as Default</button> : null }
                                                { si.main_template ? <button onClick={() => toggleComponent('duplicate-main', si)} class="dropdown-item" type="button">Duplicate</button> : <button onClick={() => toggleComponent('duplicate', si)} class="dropdown-item" type="button">Duplicate</button> }
                                            </div>
                                        </div>
                                        <div className="pull-right">
                                           { !si.main_template && <i onClick={() => confirmDialogBox('archive', si)} className="ft ft-x temp-box-icon font-weight-bold"></i> }
                                        </div>
                                    </div>
                                    <div className="card-body my-0 p-0">
                                        <img src={si.template_image} alt="si" className="img-fluid cursor-pointer"/>
                                    </div>
                                </div>
                                <div className="text-center">{ si.is_default === 1 && <i className="ft ft-check-circle temp-default-check"></i> } {si.template_name}</div>
                                {
                                    si.is_default === 1 && <div className="text-center text-primary"><span className="lbl-status temp-coming-soon">DEFAULT</span></div>
                                }
                            </div>
                        ))
                    }

                    <div className="col-lg-2 col-sm-6 col-12">
                        <div className="card temp-box">
                            <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                <div className="m-auto">
                                    <span className="mt-0 lbl-status temp-coming-soon">Coming Soon</span>
                                </div>
                            </div>
                            <div className="card-body my-0 p-0">
                                <span><i className="ft ft-plus-circle temp-plus-icon"></i></span>
                                <img src="/template-setting/blank.png" alt="si" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}


const mapStateToProps = state => ({
    setting_app: state.setting_app,
    loading: state.si_template_setting.loading,
    si_template_settings: state.si_template_setting.si_template_settings
});

export default connect(mapStateToProps, { getSITemplateSettings, toggleComponent, confirmDialogBox })(SITSList);
